<div class="group" [class.active]="active" [title]="title">
    <div class="label">{{ label }}</div>
    <div class="counter" *ngIf="counter >= 0">{{ counter }}</div>
</div>
